// NOTE: 如果購物車中已經有紅雞小或紅幼雞小，則不能再加入其他 sku (冷凍商品不能同時有大小包)
export const limitedFrozenSku = ['紅雞小', '紅幼雞小']
